import { FormEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, RouterProps } from 'react-router';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import { InputBackOffice } from '../../components/common/InputBackoffice';
import { ErrorToast } from '../../components/common/Toasts/Toasts';
import { AuthLayoutTitle } from '../../styles/GlobalComponents';
import { Label } from '../../styles/stylesStyled';
import Spinner from '../../components/common/Spinner';
import { getReferrerValidation } from './Referral.actions';

const captchaId = process.env.REACT_APP_CAPTCHA_ID;

const Referral = ({ history }: RouteComponentProps) => {
  const { t } = useTranslation('onboarding');

  const dispatch = useAppDispatch();
  const { loading } = useAppSelector((state) => state.auth);
  const [referrerId, setReferrerId] = useState('');
  const [captchaLoading, setCaptchaLoading] = useState(false);

  const onHandleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!referrerId) return ErrorToast(t('referral.error_referral_empty'));

    setCaptchaLoading(true);
    window?.initGeetest4(
      {
        captchaId,
        language: 'eng',
        product: 'bind',
        riskType: 'slide',
        nativeButton: {
          width: '100%',
          marginBottom: '20px'
        }
      },
      function (captcha: any) {
        captcha.showBox();
        captcha
          .onReady(function () {
            setCaptchaLoading(false);
          })
          .onSuccess(function () {
            const result = captcha.getValidate();
            dispatch(
              getReferrerValidation({
                referrerId: Number(referrerId),
                result,
                history
              })
            );
          })
          .onError(function () {
            setCaptchaLoading(false);
          });
      }
    );
  };

  return (
    <>
      {loading || (captchaLoading && <Spinner fullScreen={true} transparent />)}

      <AuthLayoutTitle>{t('referral.title')}</AuthLayoutTitle>
      <form onSubmit={onHandleSubmit}>
        <Label>{t('referral.label')}</Label>
        <InputBackOffice
          id={'referral'}
          type={'number'}
          placeholder={t('referral.placeholder')}
          name={'referral'}
          value={referrerId}
          onChange={setReferrerId}
          label={t('referral.label')}
        />
        <Button type='submit' m='30px 0 10px 0' disabled={!referrerId}>
          {t('referral.button_text')}
        </Button>
      </form>
    </>
  );
};

export default Referral;
